// Tablo Sütunlarını Özelleştir penceresi kullanım rehberi (Ürün ve Stok, Stok Hareket Raporu, Fiyat Değişim Logları ortak). Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.tableSettings';

export const inventoryTableSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Tablo sütunları nasıl özelleştirilir?'),
  intro: t(`${G}.intro`, 'Bu pencerede, açtığınız listede görmek istediğiniz sütunları ihtiyaçlarınıza göre açıp kapatabilirsiniz. Ayarlar yalnız bu pencereyi açtığınız tabloyu etkiler.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Sütun listesi'),
    footer: t(`${G}.regions.footer`, 'Kaydet / İptal'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Sabit sütunlar her zaman görünür'),
      text: t(`${G}.s1.text`, '"Sabit Sütunlar" bölümündekiler sistem akışı için zorunludur; bu yüzden her zaman görünür kalır ve kapatılamaz. Bu sütunlarda yalnız sıralamayı açıp kapatabilirsiniz (sıralamayı destekleyenlerde).'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Diğer sütunları açın veya kapatın'),
      text: t(`${G}.s2.text`, '"Özelleştirilebilir Sütunlar" bölümünde "Görünür" anahtarı sütunun listede görünüp görünmeyeceğini belirler. İşinize yaramayan sütunları kapatarak tabloyu sadeleştirin.'),
      tips: [
        t(`${G}.s2.tip1`, 'Bir sütunun ne gösterdiğini öğrenmek için yanındaki bilgi simgesinin üzerine gelin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Sıralamayı ayarlayın'),
      text: t(`${G}.s3.text`, '"Sırala" anahtarı, ilgili alanda sıralama kullanılıp kullanılamayacağını belirler. Bir sütunu gizlediğinizde sıralaması da kendiliğinden kapanır.'),
      tips: [
        t(`${G}.s3.tip1`, 'Sıra no, İşlemler gibi bazı sütunlar sıralamayı desteklemez; bunlarda "Sırala" anahtarı görünmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kaydedin'),
      text: t(`${G}.s4.text`, '"Değişiklikleri Kaydet" butonuna bastığınızda tercihleriniz korunur ve tablo bir sonraki açılışta aynı düzende gelir. "İptal" yaptığınız değişiklikleri uygulamadan pencereyi kapatır.'),
    },
  ],
});
